import React, { memo } from 'react'
import { View, StyleSheet } from 'react-native'
import { dataTypes } from '@adalo/constants'

import { isEqual } from 'lodash'

import { CellData } from './TableTypes'

import TextCell from './TextCell'
import NumberCell from './NumberCell'
import DateCell from './DateCell'
import LocationCell from './LocationCell'
import FileCell from './FileCell'
import ImageCell from './ImageCell'
import BooleanCell from './BooleanCell'

export type Row = {
  id: number
  cells: CellData[]
}

interface TableRowProps {
  data: Row
  isLastRow: boolean
}

const TableRow = ({ data, isLastRow }: TableRowProps): JSX.Element => {
  const renderCell = (cell: CellData) => {
    switch (cell.type) {
      case dataTypes.TEXT:
        return <TextCell cell={cell} />
      case dataTypes.NUMBER:
        return <NumberCell cell={cell} />
      case dataTypes.DATE:
      case dataTypes.DATE_ONLY:
        return <DateCell cell={cell} />
      case dataTypes.LOCATION:
        return <LocationCell cell={cell} />
      case dataTypes.FILE:
        return <FileCell cell={cell} />
      case dataTypes.IMAGE:
        return <ImageCell cell={cell} />
      case dataTypes.BOOLEAN:
        return <BooleanCell cell={cell} />
      default:
        return null
    }
  }

  return (
    <View style={[styles.row, isLastRow && styles.lastRow]}>
      {data.cells.map((cell: CellData) => (
        <View key={cell.fieldId} style={[styles.cell, cell.style]}>
          {renderCell(cell)}
        </View>
      ))}
    </View>
  )
}

export default memo(TableRow, isEqual)

export const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    alignItems: 'center',
    height: 50,
  },
  lastRow: {
    borderBottomWidth: 0,
  },
  cell: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  cellText: {
    textAlign: 'center',
    color: '#333',
  },
})
